import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import RameshwarNishad from "../assets/img/faculty/Rameshwar Nishad.webp";
import NukeshKumar from "../assets/img/faculty/NukeshKumar.webp";
import DrPoonamVerma from "../assets/img/faculty/Dr. Poonam Verma.webp";
import DrRajeshKumar from "../assets/img/faculty/Dr. Rajesh Kumar.webp";
import NareshDHRUW from "../assets/img/faculty/Naresh DHRUW.webp";
import DrSushreetaPatnaik from "../assets/img/faculty/Dr. Sushreeta Patnaik.webp";
import DrSarbheswarmishra from "../assets/img/faculty/Dr.sarbheswarmishra.webp";
import LalitaSahu from "../assets/img/faculty/Lalita Sahu.webp";
import TWINKALDEEPAK from "../assets/img/faculty/TWINKAL DEEPAK.webp";
import DrRitaDiwanjee from "../assets/img/faculty/Dr.RitaDiwanjee.webp";
import DrDiwakarRTripathi from "../assets/img/faculty/Dr. Diwakar R Tripathi.webp";
import LUKESHWARSAHU from "../assets/img/faculty/LUKESHWAR SAHU.webp";
import GovindaSahu from "../assets/img/faculty/GovindaSahu.webp";
import HimanshiSahu from "../assets/img/faculty/Himanshi Sahu.webp";
import LukeshKumarThakur from "../assets/img/faculty/Lukesh Kumar Thakur.webp";
import DrManishKumarPandey from "../assets/img/faculty/Dr. Manish Kumar Pandey.webp";
import DrAkankshaDubey from "../assets/img/faculty/Dr. Akanksha Dubey.webp";
import HemantPandey from "../assets/img/faculty/Hemant Pandey.webp";
import SunilKumarSahu from "../assets/img/faculty/Sunil Kumar Sahu.webp";
import RanuVerma from "../assets/img/faculty/Ranu Verma.webp";
import DrSubhashishBiswas from "../assets/img/faculty/Dr. Subhashish biswas.webp";
import DrSanjayPandey from "../assets/img/faculty/Dr. Sanjay Pandey.webp";
import RekhaSahu from "../assets/img/faculty/Rekha Sahu.webp";
import DrPVishwanathan from "../assets/img/faculty/Dr. P Vishwanathan.webp";
import Laxmikant from "../assets/img/faculty/Laxmikant.webp";
import DrNKSwamy from "../assets/img/faculty/Dr. N K Swamy.webp";
import DrAbhaTambrakar from "../assets/img/faculty/Dr.AbhaTambrakar.webp";
import DrAnkitMishra from "../assets/img/faculty/Dr. Ankit Mishra.webp";
import MrAbhijeetRamani from "../assets/img/faculty/Mr. Abhijeet Ramani.webp";
import VageshKumbhakar from "../assets/img/faculty/Vagesh Kumbhakar.webp";
import SanjeevJangde from "../assets/img/faculty/SanjeevJangde.webp";
import TAKESHWARKAUSHIK from "../assets/img/faculty/TAKESHWAR KAUSHIK.webp";
import KhemanshuKumarSahu from "../assets/img/faculty/Khemanshu Kumar Sahu.webp";
import DushyantYadav from "../assets/img/faculty/Dushyant yadav.webp";
import KrishnaKumar from "../assets/img/faculty/krishna kumar.webp";
import MohitChelak from "../assets/img/faculty/Mohit Chelak.webp";
import DrAnitaKurre from "../assets/img/faculty/Dr. Anita Kurre.webp";
import DrAshwaniKumarSahu from "../assets/img/faculty/Dr.AshwaniKumarSahu.webp";
import DrYogmayaupadhyaya from "../assets/img/faculty/Dr.yogmayaupadhyaya.webp";
import DrGarimaDiwan from "../assets/img/faculty/Dr. Garima Diwan.webp";
import DrShefaliYateenJain from "../assets/img/faculty/Dr.ShefaliYateenJain.webp";
import Harishpradhan from "../assets/img/faculty/Harishpradhan.webp";
import VikasKumarSahu from "../assets/img/faculty/Vikas Kumar Sahu.webp";
import ASHWANEEKUMARSAHU from "../assets/img/faculty/ASHWANEE KUMAR SAHU.webp";
import DrPratimaVishwakarma from "../assets/img/faculty/Dr. Pratima Vishwakarma.webp";
import Bhamtisahu from "../assets/img/faculty/bhamtisahu.webp";
import Kishorekumarkhattar from "../assets/img/faculty/kishorekumarkhattar.webp";
import DrDiamondSahu from "../assets/img/faculty/Dr. Diamond Sahu.webp";
import DrNirajChaubey from "../assets/img/faculty/Dr. Niraj Chaubey.webp";
import DrKiranBalaPatel from "../assets/img/faculty/Dr. Kiran Bala Patel.webp";
import DrDiwakarTiwari from "../assets/img/faculty/Dr. Diwakar Tiwari.webp";
import DrPreetamSahu from "../assets/img/faculty/Dr.PreetamSahu.webp";
import RajendraPrasadGendre from "../assets/img/faculty/Rajendra Prasad Gendre.webp";
import DrShameemAhmadKhan from "../assets/img/faculty/Dr. Shameem Ahmad Khan.webp";
import AfrozQurashi from "../assets/img/faculty/Afroz Qurashi.webp";
import SumedhaTiwari from "../assets/img/faculty/Sumedha Tiwari.webp";
import AjayKumar from "../assets/img/faculty/Ajay Kumar.webp";
import Bhuneshwari from "../assets/img/faculty/Bhuneshwari.webp";
import ShishirVyas from "../assets/img/faculty/Shishir Vyas.webp";
import SandeepGokhale from "../assets/img/faculty/Sandeep Gokhale.webp";
import BheemSingh from "../assets/img/faculty/Bheem Singh.webp";
import HimanshutaSahu from "../assets/img/faculty/Himanshuta Sahu.webp";
import AKASHGUPTA from "../assets/img/faculty/AKASH GUPTA.webp";
import ChhayangiBalaMahamala from "../assets/img/faculty/Chhayangi Bala mahamala.webp";
import RAGINISONI from "../assets/img/faculty/RAGINI SONI.webp";
import AishwariyaSoni from "../assets/img/faculty/Aishwariya Soni.webp";
import DrVimlaSona from "../assets/img/faculty/Dr. Vimla Sona.webp";
import DrBirendraKumarPadhee from "../assets/img/faculty/Dr. Birendra Kumar Padhee.webp";
import DrJHVyas from "../assets/img/faculty/Dr. J H Vyas.webp";
import DrNidhiGeoneka from "../assets/img/faculty/Dr. Nidhi Geoneka.webp";
import KesharLataSahu from "../assets/img/faculty/Keshar Lata Sahu.webp";
import DrImranNadeemSiddiqui from "../assets/img/faculty/Dr. Imran Nadeem Siddiqui.webp";
import DrShantanuSBose from "../assets/img/faculty/Dr. Shantanu S Bose.webp";
import HeenaJaisinghani from "../assets/img/faculty/Heena Jaisinghani.webp";
import SijiReno from "../assets/img/faculty/Siji Reno.webp";
import SiddharthMishra from "../assets/img/faculty/Siddharth Mishra.webp";
import DrJayKumarDewangan from "../assets/img/faculty/Dr. Jay Kumar Dewangan.webp";
import RohitKumarSinha from "../assets/img/faculty/Rohit Kumar Sinha.webp";
import IshaSahu from "../assets/img/faculty/IshaSahu.webp";
import Hirananddevangan from "../assets/img/faculty/hirananddevangan.webp";
import VIKASSAHU from "../assets/img/faculty/VIKAS SAHU.webp";
import YugalKishorRajput from "../assets/img/faculty/Yugal Kishor Rajput.webp";
import RajendraSahu from "../assets/img/faculty/Rajendra sahu.webp";
import ChandrakantYadav from "../assets/img/faculty/ChandrakantYadav.webp";
import AvinashDewangan from "../assets/img/faculty/AvinashDewangan.webp";
import ShikharMishra from "../assets/img/faculty/Shikhar Mishra.webp";
import SumanVerma from "../assets/img/faculty/Suman Verma.webp";
import PratibhaJaiswal from "../assets/img/faculty/Pratibha Jaiswal.webp";
import Surendra from "../assets/img/faculty/Surendra.webp";
import Trivendra from "../assets/img/faculty/Trivendra.webp";
import DrDineshChandraDesai from "../assets/img/faculty/Dr. Dinesh chandra Desai.webp";
import VenuSahu from "../assets/img/faculty/venuSahu.webp";

const faculty = [
    { id: 1, name: "Mr. Rameshwar Nishad", designation: "Assistant Professor", department: "Botany", image: RameshwarNishad },
    { id: 2, name: "Mr. Lukeshwar Kumar", designation: "Assistant Professor", department: "Botany", image: NukeshKumar },
    { id: 3, name: "Dr. Poonam Verma", designation: "Assistant Professor", department: "Botany", image: DrPoonamVerma },
    { id: 4, name: "Dr. Rajesh Kumar", designation: "Associate Professor", department: "Botany", image: DrRajeshKumar },
    { id: 5, name: "Dr. Prakash Chand Sahu", designation: "Assistant Professor", department: "Botany", image: "" },
    { id: 6, name: "Mr. Naresh Dhruw", designation: "Assistant Professor", department: "Chemistry", image: NareshDHRUW },
    { id: 7, name: "Dr. Sushreeta Patnaik", designation: "Associate Professor", department: "Chemistry", image: DrSushreetaPatnaik },
    { id: 8, name: "Dr. Sarbeswar Mishra", designation: "Professor", department: "Chemistry", image: DrSarbheswarmishra },
    { id: 9, name: "Ms. Lalita Sahu", designation: "Assistant Professor", department: "Chemistry", image: LalitaSahu },
    { id: 10, name: "Ms. Twinkal Deepak", designation: "Assistant Professor", department: "Chemistry", image: TWINKALDEEPAK },
    { id: 11, name: "Dr. Rita Dewanjee", designation: "Professor", department: "Computer Science & Information Technology", image: DrRitaDiwanjee },
    { id: 12, name: "Dr. Diwakar R. Tripathi", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: DrDiwakarRTripathi },
    { id: 13, name: "Mr. Nukesh Sahu", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: LUKESHWARSAHU },
    { id: 14, name: "Mr. Govinda", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: GovindaSahu },
    { id: 15, name: "Mr. Dameshwar Sahu", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: LUKESHWARSAHU },
    { id: 16, name: "Ms. Himanshi Sahu", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: HimanshiSahu },
    { id: 17, name: "Mr. Lukesh Kumar Thakur", designation: "Assistant Professor", department: "Computer Science & Information Technology", image: LukeshKumarThakur },
    { id: 18, name: "Dr. Badri Vishal Padamwar", designation: "Professor", department: "Mathematics", image: "" },
    { id: 19, name: "Dr. Manish Kumar Pandey", designation: "Assistant Professor", department: "Mathematics", image: DrManishKumarPandey },
    { id: 20, name: "Dr. Akanksha Dubey", designation: "Associate Professor", department: "Mathematics", image: DrAkankshaDubey },
    { id: 21, name: "Mr. Hemant Pandey", designation: "Assistant Professor", department: "Mathematics", image: HemantPandey },
    { id: 22, name: "Mr. Sunil Kumar", designation: "Assistant Professor", department: "Mathematics", image: SunilKumarSahu },
    { id: 23, name: "Ms. Ranu Verma", designation: "Assistant Professor", department: "Mathematics", image: RanuVerma },
    { id: 24, name: "Dr. Subhashish Biswas", designation: "Professor", department: "Mathematics", image: DrSubhashishBiswas },
    { id: 25, name: "Dr. Sanjay Pandey", designation: "Professor", department: "Physics", image: DrSanjayPandey },
    { id: 26, name: "Dr. O P Verma", designation: "Assistant Professor", department: "Physics", image: "" },
    { id: 27, name: "Ms. Rekha Sahu", designation: "Assistant Professor", department: "Physics", image: RekhaSahu },
    { id: 28, name: "Dr. P. Visvanathan", designation: "Professor", department: "Zoology", image: DrPVishwanathan },
    { id: 29, name: "Mr. Laxmikant Sinha", designation: "Assistant Professor", department: "Zoology", image: Laxmikant },
    { id: 30, name: "Dr. N. Kumar Swamy", designation: "Professor", department: "Electrical Electronics Engineering", image: DrNKSwamy },
    { id: 31, name: "Dr. Abha Tamrakar", designation: "Assistant Professor", department: "Computer Science Engineering", image: DrAbhaTambrakar },
    { id: 32, name: "Dr. Ankit Mishra", designation: "Assistant Professor", department: "Electrical Electronics Engineering", image: DrAnkitMishra },
    { id: 33, name: "Mr. Abhijeet Ramani", designation: "Assistant Professor", department: "Computer Science Engineering", image: MrAbhijeetRamani },
    { id: 34, name: "Mr. Vagesh Kumar", designation: "Assistant Professor", department: "Civil Engineering", image: VageshKumbhakar },
    { id: 35, name: "Mr. Sanjeev Jangde", designation: "Assistant Professor", department: "Civil Engineering", image: SanjeevJangde },
    { id: 36, name: "Mr. Takeshwar Kaushik", designation: "Assistant Professor", department: "Mechanical Engineering", image: TAKESHWARKAUSHIK },
    { id: 37, name: "Mr. Khemanshu Kumar Sahu", designation: "Assistant Professor", department: "Mechanical Engineering", image: KhemanshuKumarSahu },
    { id: 38, name: "Mr. Dushyant Kumar Yadav", designation: "Assistant Professor", department: "Electrical Electronics Engineering", image: DushyantYadav },
    { id: 39, name: "Mr. Krishna Kumar Sahu", designation: "Assistant Professor", department: "Political Science and Public Administration", image: KrishnaKumar },
    { id: 40, name: "Mr. Mohit Ram Chelak", designation: "Assistant Professor", department: "Political Science and Public Administration", image: MohitChelak },
    { id: 41, name: "Dr. Anita Kurre", designation: "Professor", department: "Sociology", image: DrAnitaKurre },
    { id: 42, name: "Dr. Ashwani Sahu", designation: "Assistant Professor", department: "Sociology", image: DrAshwaniKumarSahu },
    { id: 43, name: "Dr. Yogmaya Upadhyay", designation: "Professor", department: "Sociology", image: DrYogmayaupadhyaya },
    { id: 44, name: "Dr. Garima Diwan", designation: "Assistant Professor", department: "English", image: DrGarimaDiwan },
    { id: 45, name: "Dr. Shefali Yateen Jain", designation: "Associate Professor", department: "English", image: DrShefaliYateenJain },
    { id: 46, name: "Mr. Mukul Thakur", designation: "Assistant Professor", department: "English", image: "" },
    { id: 47, name: "Mr. Harish Pradhan", designation: "Assistant Professor", department: "English", image: Harishpradhan },
    { id: 48, name: "Mr. Ashok Kumar Sahu", designation: "Assistant Professor", department: "English", image: VikasKumarSahu },
    { id: 49, name: "Dr. Sandeep Kumar Sahu", designation: "Associate Professor", department: "Geography", image: ASHWANEEKUMARSAHU },
    { id: 50, name: "Dr. Pratima Vishwakarma", designation: "Assistant Professor", department: "Geography", image: DrPratimaVishwakarma },
    { id: 51, name: "Ms. Bhamti Sahu", designation: "Assistant Professor", department: "Geography", image: Bhamtisahu },
    { id: 52, name: "Mr. Kishor Kumar Kathar", designation: "Assistant Professor", department: "Geography", image: Kishorekumarkhattar },
    { id: 53, name: "Dr. Diamond Sahu", designation: "Assistant Professor", department: "Hindi", image: DrDiamondSahu },
    { id: 54, name: "Dr. Niraj Chaubey", designation: "Assistant Professor", department: "Hindi", image: DrNirajChaubey },
    { id: 55, name: "Dr. Kiran Bala Patel", designation: "Assistant Professor", department: "Hindi", image: DrKiranBalaPatel },
    { id: 56, name: "Dr. Diwakar Tiwari", designation: "Assistant Professor", department: "Hindi", image: DrDiwakarTiwari },
    { id: 57, name: "Mr. Ramesh Kumar", designation: "Assistant Professor", department: "Hindi", image: DrRajeshKumar },
    { id: 58, name: "Dr. Preetam Sahu", designation: "Assistant Professor", department: "History & archaeology", image: DrPreetamSahu },
    { id: 59, name: "Mr. Rajendra Prasad Gendre", designation: "Assistant Professor", department: "Law", image: RajendraPrasadGendre },
    { id: 60, name: "Dr. Shameem Ahmad Khan", designation: "Associate Professor", department: "Law", image: DrShameemAhmadKhan },
    { id: 61, name: "Ms. Afroz Kuraishi", designation: "Assistant Professor", department: "Law", image: AfrozQurashi },
    { id: 62, name: "Ms. Sumedha Tiwari", designation: "Assistant Professor", department: "Law", image: SumedhaTiwari },
    { id: 63, name: "Mr. Ajay Kumar", designation: "Assistant Professor", department: "Law", image: AjayKumar },
    { id: 64, name: "Ms. Bhuneshwari", designation: "Assistant Professor", department: "Law", image: Bhuneshwari },
    { id: 65, name: "Mr. Shishir Vyas", designation: "Assistant Professor", department: "Law", image: ShishirVyas },
    { id: 66, name: "Mr. Sandeep Gokhale", designation: "Assistant Professor", department: "Law", image: SandeepGokhale },
    { id: 67, name: "Mr. Bheem Singh", designation: "Assistant Professor", department: "Law", image: BheemSingh },
    { id: 68, name: "Ms. Himashuta Sahu", designation: "Assistant Professor", department: "Law", image: HimanshutaSahu },
    { id: 69, name: "Mr. Gajendra Kumar Yadaw", designation: "Assistant Professor", department: "Law", image: "" },
    { id: 70, name: "Mr. Akash Gupta", designation: "Assistant Professor", department: "Law", image: AKASHGUPTA },
    { id: 71, name: "Ms. Chhayangi Bala Mahamala", designation: "Assistant Professor", department: "Law", image: ChhayangiBalaMahamala },
    { id: 72, name: "Ms. Ragini Soni", designation: "Assistant Professor", department: "Law", image: RAGINISONI },
    { id: 73, name: "Ms. Aishwarya R. L. Soni", designation: "Assistant Professor", department: "Law", image: AishwariyaSoni },
    { id: 74, name: "Dr. Vimla Sona", designation: "Assistant Professor", department: "Library & Information Science", image: DrVimlaSona },
    { id: 75, name: "Dr. Birendra Kumar Padhee", designation: "Professor", department: "Library & Information Science", image: DrBirendraKumarPadhee },
    { id: 76, name: "Ms. Neelam", designation: "Assistant Professor", department: "Library & Information Science", image: "" },
    { id: 77, name: "Dr. J. H. Vyas", designation: "Professor", department: "Commerce & Management", image: DrJHVyas },
    { id: 78, name: "Dr. Vandana Kashyap", designation: "Associate Professor", department: "Commerce & Management", image: "" },
    { id: 79, name: "Dr. Nidhi Goenka", designation: "Associate Professor", department: "Commerce & Management", image: DrNidhiGeoneka },
    { id: 80, name: "Ms. Keshar Lata Sahu", designation: "Assistant Professor", department: "Commerce & Management", image: KesharLataSahu },
    { id: 81, name: "Dr. Imran Nadeem Siddiqui", designation: "Professor", department: "Commerce & Management", image: DrImranNadeemSiddiqui },
    { id: 82, name: "Dr. Shantanu S. Bose", designation: "Associate Professor", department: "Commerce & Management", image: DrShantanuSBose },
    { id: 83, name: "Ms. Heena Jaisinghani", designation: "Assistant Professor", department: "Commerce & Management", image: HeenaJaisinghani },
    { id: 84, name: "Ms. Siji Reno", designation: "Assistant Professor", department: "Commerce & Management", image: SijiReno },
    { id: 85, name: "Mr. Shidharth Mishra", designation: "Assistant Professor", department: "Commerce & Management", image: SiddharthMishra },
    { id: 86, name: "Dr. Jay Kumar Dewangan", designation: "Professor", department: "Commerce & Management", image: DrJayKumarDewangan },
    { id: 87, name: "Mr. Rohit Kumar Sinha", designation: "Assistant Professor", department: "Commerce & Management", image: RohitKumarSinha },
    { id: 88, name: "Msr. Isha Sahu", designation: "Assistant Professor", department: "Commerce & Management", image: IshaSahu },
    { id: 89, name: "Mr. Keshav Sahu", designation: "Assistant Professor", department: "Pharmacy", image: LUKESHWARSAHU },
    { id: 90, name: "Mr. Hiranand Dewangan", designation: "Assistant Professor", department: "Pharmacy", image: Hirananddevangan },
    { id: 91, name: "Mr. Vikas Sahu", designation: "Assistant Professor", department: "Pharmacy", image: VIKASSAHU },
    { id: 92, name: "Mr. Bhisham Sahu", designation: "Assistant Professor", department: "Pharmacy", image: IshaSahu },
    { id: 93, name: "Mr. Yugal Kishor Rajput", designation: "Assistant Professor", department: "Pharmacy", image: YugalKishorRajput },
    { id: 94, name: "Mr. Ashwanee Kumar Sahu", designation: "Assistant Professor", department: "Pharmacy", image: ASHWANEEKUMARSAHU },
    { id: 95, name: "Mr. Rajendra Kumar Sahu", designation: "Assistant Professor", department: "Pharmacy", image: RajendraSahu },
    { id: 96, name: "Mr. Chandrakant Yadav", designation: "Assistant Professor", department: "Pharmacy", image: ChandrakantYadav },
    { id: 97, name: "Mr. Avinash Dewangan", designation: "Assistant Professor", department: "Pharmacy", image: AvinashDewangan },
    { id: 98, name: "Mr. Shikhar Mishra", designation: "Assistant Professor", department: "Pharmacy", image: ShikharMishra },
    { id: 99, name: "Ms. Suman Verma", designation: "Assistant Professor", department: "Pharmacy", image: SumanVerma },
    { id: 100, name: "Ms. Pratibha Jaiswal", designation: "Assistant Professor", department: "Pharmacy", image: PratibhaJaiswal },
    { id: 101, name: "Mr. Surendra", designation: "Assistant Professor", department: "Pharmacy", image: Surendra },
    { id: 102, name: "Mr. Trivendra Ku Sahu", designation: "Assistant Professor", department: "Pharmacy", image: Trivendra },
    { id: 103, name: "Dr. Dineshchandra G Desai", designation: "Professor", department: "Pharmacy", image: DrDineshChandraDesai },
    { id: 104, name: "Mr. Vikash Kumar Sahu", designation: "Assistant Professor", department: "Pharmacy", image: VikasKumarSahu },
    { id: 105, name: "Ms. Venu Sahu", designation: "Assistant Professor", department: "Pharmacy", image: VenuSahu },
];


function getInitials(name) {
    const cleaned = name.replace(/Prof\.|Dr\.|\(|\)/gi, "").trim();
    const meaningful = cleaned
        .split(/\s+/)
        .filter((word) => !["Faculty", "Name"].includes(word));

    return (
        meaningful
            .slice(0, 2)
            .map((word) => word.charAt(0))
            .join("")
            .toUpperCase() || "FM"
    );
}

function FacultyCard({ member }) {
    return (
        <article className="fss__card">
            <div className="fss__portrait">
                {member.image ? (
                    <img src={member.image} alt={member.name} loading="lazy" />
                ) : (
                    <div className="fss__portrait-fallback" aria-label={member.name}>
                        <span>{getInitials(member.name)}</span>
                        <small>Add faculty photo</small>
                    </div>
                )}

                <span className="fss__department">{member.department}</span>
            </div>

            <div className="fss__card-body">
                <span className="fss__designation">{member.designation}</span>
                <h3>{member.name}</h3>
            </div>
        </article>
    );
}

function Faculty({ eyebrow, title, accent, description, light = false }) {
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        dots: false,
        arrows: false,
        infinite: faculty.length > 4,
        speed: 650,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4500,
        pauseOnHover: true,
        swipeToSlide: true,
        adaptiveHeight: false,
        centerMode: false,
        variableWidth: false,
        beforeChange: (_, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 1180,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    };

    const progress = ((currentSlide + 1) / faculty.length) * 100;

    return (
        <section className="fss" aria-labelledby="faculty-section-title">
            <div className="fss__container">
                <header className="fss__header">
                    <div className="fss__heading">
                        <span className="fss__eyebrow">Our faculty</span>
                        <h2 id="faculty-section-title">
                            Learn from accomplished
                            <em> academicians and practitioners.</em>
                        </h2>
                    </div>

                    <div className="fss__header-side">
                        <p>
                            Experienced educators who combine subject knowledge, industry
                            insight and personal mentorship to create an engaging management
                            learning environment.
                        </p>
                        <a href="/faculty">View all faculty <span>↗</span></a>
                    </div>
                </header>

                <div className="fss__slider-wrap">
                    <Slider ref={sliderRef} {...settings}>
                        {faculty.map((member) => (
                            <div className="fss__slide" key={member.id}>
                                <FacultyCard member={member} />
                            </div>
                        ))}
                    </Slider>
                </div>

                <footer className="fss__controls">
                    <div className="fss__count" aria-live="polite">
                        <span>{String(currentSlide + 1).padStart(2, "0")}</span>
                        <i />
                        <span>{String(faculty.length).padStart(2, "0")}</span>
                    </div>

                    <div className="fss__progress" aria-hidden="true">
                        <span style={{ width: `${progress}%` }} />
                    </div>

                    <div className="fss__arrows">
                        <button
                            type="button"
                            onClick={() => sliderRef.current?.slickPrev()}
                            aria-label="Previous faculty"
                        >
                            ←
                        </button>
                        <button
                            type="button"
                            onClick={() => sliderRef.current?.slickNext()}
                            aria-label="Next faculty"
                        >
                            →
                        </button>
                    </div>
                </footer>
            </div>
        </section>
    );
}
export default Faculty;